import { useCallback, useEffect, useState } from 'react';
import {
  fetchConceptos,
  createConcepto,
  updateConcepto,
  toggleConceptoStatus,
} from '../services/conceptos';

export function useConceptosCrud() {
  const [items, setItems] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isMutating, setIsMutating] = useState(false);

  const cargar = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const data = await fetchConceptos();
      setItems(Array.isArray(data) ? data : []);
    } catch (err) {
      setError(err);
      setItems([]);
    } finally {
      setIsLoading(false);
    }
  }, []);

  const crear = useCallback(async ({ deConcepto, tpConcepto, feRegistro }) => {
    setIsMutating(true);
    try {
      return await createConcepto({ deConcepto, tpConcepto, feRegistro });
    } finally {
      setIsMutating(false);
    }
  }, []);

  const actualizar = useCallback(async (cdConcepto, deConcepto) => {
    setIsMutating(true);
    try {
      return await updateConcepto(cdConcepto, deConcepto);
    } finally {
      setIsMutating(false);
    }
  }, []);

  const toggleEstado = useCallback(async (cdConcepto) => {
    setIsMutating(true);
    try {
      return await toggleConceptoStatus(cdConcepto);
    } finally {
      setIsMutating(false);
    }
  }, []);

  useEffect(() => {
    cargar();
  }, [cargar]);

  return { items, isLoading, error, isMutating, cargar, crear, actualizar, toggleEstado };
}